
export default {
  inject: ['getParam', 'getIsInit'],
  computed: {
    param() {
      return this.getParam();
    },
    isInit() {
      return this.getIsInit();
    },

  },
  watch: {
    param: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            if (this.param && this.isInit) {
              this.isInit = false;
              this.setTimeout(() => {
                this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
              }, 1000);
            } else {
              this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
            }
          });
        }
      },
      immediate: true
    },
  },

};
